import { rootBkndPath } from "../util/link";

export async function fetchFeeConfig() {
  const resp = await fetch(`${rootBkndPath}/api/coinConfig/fees`, {
    // if your server requires cookies/auth to read this endpoint:
    // credentials: 'include'
  });
  if (!resp.ok) {
    throw new Error('Failed to load fee config');
  }

  // Consume the JSON body exactly once:
  const data = await resp.json();
 

  return data;
}

